import { logChannelRequestFailure } from 'setup/logger/logChannelRequestFailure';
import { serviceWorkerConfigClient } from 'shared/domain/serviceWorkerConfig/serviceWorkerConfigClient';
import { ISO6391LanguageCode } from 'shared/types/locale';
import { getUiStoreState } from 'store/ui';

/** Shows the app in `locale`; the worker downloads the project data in it again. */
export function changeAppLanguage(locale: ISO6391LanguageCode): void {
  getUiStoreState().actions.setLocale(locale);
  serviceWorkerConfigClient
    .changeLanguage()
    .catch((error: unknown) => logChannelRequestFailure('Could not change the service worker language', error));
}
